export class RequestNewInstanceGC {

    intIdFurHI: number;
    intIdFurHICanal: number;
    strCodFurHI: string;
    numFormulario: string;
    tipoDenunciante: string;
    canal: string;
    unidad: string;
    entidadInvolucrada: string;
    tipoDivision: string;
}
